import type { Permission } from '@/auth/permissions'
import { usePermission } from '@/hooks/usePermission'

interface Props {
  perm: Permission
  children: React.ReactNode
  fallback?: React.ReactNode
}

/**
 * RequirePermission conditionally renders children based on the user's permissions.
 * Use this for fine-grained UI element visibility (buttons, tabs, actions).
 *
 * Example:
 *   <RequirePermission perm="devices:write">
 *     <button>Add Device</button>
 *   </RequirePermission>
 */
export function RequirePermission({ perm, children, fallback = null }: Props) {
  const allowed = usePermission(perm)
  return allowed ? <>{children}</> : <>{fallback}</>
}
